<template>
  <div class="dropdown">
    <button
      class="btn btn-outline-secondary dropdown-toggle w-100"
      type="button"
      data-bs-toggle="dropdown"
      data-bs-auto-close="outside"
      aria-expanded="false"
    >
      Branches ({{ selectedRepoCount }})
    </button>
    <ul class="dropdown-menu w-100 p-2" style="min-width: 300px; max-height: 500px; overflow-y: auto">
      <template v-for="repoOrigin in selectedRepositories" :key="repoOrigin">
        <li class="dropdown-header">
          {{ getRepositoryName(repoOrigin) }}
        </li>

        <li
          v-for="branch in getBranchesForRepo(repoOrigin)"
          :key="repoOrigin + '-' + branch"
          @click.stop="selectBranch(repoOrigin, branch)"
          class="branch-option"
        >
          <div class="dropdown-item d-flex align-items-center">
            <div class="form-check flex-grow-1">
              <input
                class="form-check-input"
                type="radio"
                :name="'branch-' + repoOrigin"
                :id="'branch-' + repoOrigin + '-' + branch"
                :checked="selectedBranches[repoOrigin] === branch"
                @click.stop
              />
              <label class="form-check-label w-100" :for="'branch-' + repoOrigin + '-' + branch">
                {{ branch }}
              </label>
            </div>
          </div>
        </li>

        <li v-if="repoOrigin !== selectedRepositories[selectedRepositories.length - 1]">
          <hr class="dropdown-divider" />
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
import { defineComponent, ref, computed, watch } from "vue";

export default defineComponent({
  name: "BranchSelector",
  props: {
    selectedRepositories: {
      type: Array,
      required: true
    },
    repositories: {
      type: Array,
      required: true
    },
    repositoryBranches: {
      type: Object,
      required: true
    },
    initialSelectedBranches: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["branchChange"],
  setup(props, { emit }) {
    const selectedBranches = ref({ ...props.initialSelectedBranches });

    watch(
      () => props.initialSelectedBranches,
      (newBranches) => {
        selectedBranches.value = { ...newBranches };
      },
      { deep: true }
    );

    const selectedRepoCount = computed(() => {
      return props.selectedRepositories.length;
    });

    function getRepositoryName(origin) {
      const repo = props.repositories.find((r) => r.origin === origin);
      return repo?.title || origin;
    }

    function getBranchesForRepo(repoOrigin) {
      return props.repositoryBranches[repoOrigin] || [];
    }

    function selectBranch(repoOrigin, branch) {
      selectedBranches.value[repoOrigin] = branch;
      emit("branchChange", { ...selectedBranches.value });
    }

    return {
      selectedBranches,
      selectedRepoCount,
      getRepositoryName,
      getBranchesForRepo,
      selectBranch
    };
  }
});
</script>

<style scoped>
.dropdown-item {
  cursor: pointer;
  user-select: none;
}

.dropdown-item:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.dropdown-header {
  font-weight: 600;
  color: #495057;
  padding: 0.5rem 1rem;
  margin-top: 0.5rem;
}

.dropdown-header:first-child {
  margin-top: 0;
}

.branch-option {
  cursor: pointer;
}

.form-check-label {
  cursor: pointer;
}
</style>
